<script setup lang="ts">
import AconnectShellLayout from '@/components/layouts/aconnect-shell-layout.vue';
import AconnectSettingsMenu from '@/components/settings/aconnect/aconnect-settings-menu.vue';
import { useTeamInfo } from '@/utils/swr';
import { useIsAdmin } from '@/utils/user';
import { useStore } from '@/utils/vue';

const store = useStore();
const { isAdmin } = useIsAdmin();
const { data: teamInfo } = useTeamInfo();
</script>

<template>
  <AconnectShellLayout subtitle="管理・設定">
    <template #menu>
      <AconnectSettingsMenu
        :is-admin="isAdmin"
        :is-user-document-enabled="!!teamInfo?.enable_user_document"
        :has-user-document-notification="
          store.state.userDocumentNotification.hasNotification
        "
      />
    </template>
    <router-view />
  </AconnectShellLayout>
</template>
